import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";

import useStyles from "./useStyles";

const Title = (props) => {
  const { children } = props;
  const classes = useStyles();

  return (
    <Typography variant="h3" className={classes.title}>
      {children}
    </Typography>
  );
};

Title.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Title;
